module.exports = __webpack_public_path__ + "static/media/App now availale.96a6787e.png";